import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-cookie-consent', 'mainTitle', 'Meie küpsised, Sinu valikud');
Labels.set('ui-cookie-consent', 'settingsTitle', 'Küpsiste seaded');
Labels.set(
    'ui-cookie-consent',
    'mainInfo',
    '{country} registreeritud Swedbanki grupi {entitiesLink} kasutavad {cookiesLink} või sarnaseid tehnoloogiaid, mis on vajalikud selle veebilehe toimimiseks. Selleks et oma kasutajakogemust parandada ja isikupärastada, saad ise valida mõningad küpsised:'
);
Labels.set(
    'ui-cookie-consent',
    'secondaryInfo',
    'Valikuliste küpsiste haldamiseks vajuta nuppu „Haldan küpsiseid“. Võid oma küpsiste nõusoleku igal ajal tagasi võtta {usageLink}. Lisateavet selle kohta, kuidas me küpsiseid kasutame, leiad {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'settingsInfo',
    'Võid igal ajal oma küpsiste nõusoleku tagasi võtta {usageLink}. Lisateavet selle kohta, kuidas me küpsiseid kasutame, leiad meie {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'thirdPartyDisclaimer',
    'Sellel veebilehel kasutatakse kolmanda osapoole küpsiseid.'
);
Labels.set('ui-cookie-consent', 'accept', 'Nõustun kõigi küpsistega');
Labels.set(
    'ui-cookie-consent',
    'decline',
    'Nõustun ainult vajalike küpsistega'
);
Labels.set('ui-cookie-consent', 'myCookies', 'Haldan küpsiseid');
Labels.set('ui-cookie-consent', 'saveChoice', 'Salvesta küpsiste seaded');
Labels.set('ui-cookie-consent', {
    COOKIE_FUNCTIONAL: 'funktsionaalsed küpsised;',
    COOKIE_ANALYTICAL: 'analüütilised küpsised;',
    COOKIE_TARGETING: 'sihtturunduse küpsised.',
});
Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Vajalikud',
    CATEGORY_ANALYTICAL: 'Analüütilised',
    CATEGORY_TARGETING: 'Sihtturunduse',
    CATEGORY_FUNCTIONAL: 'Funktsionaalsed',
});
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Vajalikud küpsised aitavad veebilehel töötada sujuvalt ja turvaliselt, sest võimaldavad kasutada selliseid funktsioone nagu sisselogimine ja keeleseaded. Vajalikke küpsiseid ei saa välja lülitada.',
    HELP_FUNCTIONAL:
        'Funktsionaalsed küpsised muudavad kasutajakogemuse sujuvamaks. Kui neist keeldud, võib Sul tekkida vajadus andmeid korduvalt sisestada, sisu filtreerida ja rohkem kerida ning jääd ilma muudest kasulikest funktsioonidest.',
    HELP_ANALYTICAL:
        'Analüütilised küpsised aitavad meil mõista, kuidas meie veebilehti kasutatakse, millised funktsioonid on populaarsed või võivad olla keerulised. Kasutame neid andmeid lehtede kasutajamugavuse suurendamiseks. Kui neist keeldud, ei koguta statistikat.',
    HELP_TARGETING:
        'Sihtturunduse küpsised lubavad Sulle pakkuda meie toodete ja teenuste kohta isikupärastatud teavet. Kui neist keeldud, ei esitata Sulle isikupärastatud sisu.',
});
Labels.set('ui-cookie-consent', 'EE', 'Eestis');
Labels.set('ui-cookie-consent', 'LV', 'Lätis');
Labels.set('ui-cookie-consent', 'LT', 'Leedus');
Labels.set('ui-cookie-consent', 'entities', 'üksused');
Labels.set('ui-cookie-consent', 'cookies', 'küpsiseid');
Labels.set('ui-cookie-consent', 'language', 'Keel');
Labels.set('ui-cookie-consent', 'usage', 'küpsiste lehel');
Labels.set(
    'ui-cookie-consent',
    'policyLinkLabel',
    'küpsiste kasutamise põhimõtetest'
);
